import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigurationResourceService } from './configurationResource.service';
import { IConfigSharedHotel } from 'libraries/hotel/models/config-shared-hotel';

@Injectable()
export class ConfigSharedHotelService {
    constructor(
      private configurationResourceService: ConfigurationResourceService
    ) {
    }

    public getConfiguration(): Observable<IConfigSharedHotel> {
        return this.configurationResourceService.get(
          ['wui', 'shared_hotel', 'config', 'details', 'hotel.json'], {}
        ) as Observable<IConfigSharedHotel>;
    }
}